import { Header } from '@tanstack/react-table';
import classnames from 'classnames';
import * as React from 'react';

import styles from '../../Table.module.scss';
import { useTableContext } from '../../TableContext';
import { SelectAllCheckbox } from '../SelectAllCheckbox';
import { TableHeader } from '../TableHeader';

type TableHeaderProps = {
  selectAllOnePageAtATime?: boolean;
  headerClassName?: string;
};

function TableHeaders<TData>({ selectAllOnePageAtATime, headerClassName }: TableHeaderProps) {
  const { getTable, isSelectable, isFilterable, isSortable } = useTableContext();

  const headerGroups = getTable()?.getHeaderGroups() || [];

  const headers = headerGroups.map((group) => (
    <tr key={group.id}>
      {isSelectable && (
        <th>
          {!isFilterable && <SelectAllCheckbox selectAllOnePageAtATime={selectAllOnePageAtATime} />}
        </th>
      )}
      {group.headers.map((header) => (
        <TableHeader<TData>
          header={header as Header<TData, unknown>}
          key={header.id}
          disableSorting={!isSortable}
        />
      ))}
    </tr>
  ));
  return (
    <thead className={classnames(styles.header, headerClassName)} key="table-head">
      {headers}
    </thead>
  );
}

export { TableHeaders };
